var _g, _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQbConnectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45672_72336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.3999 11.4374H6.38938C6.42631 10.0291 6.59851 8.70234 6.88569 7.4999H3.56701C2.93184 8.68546 2.48293 10.0214 2.3999 11.4374ZM6.38938 12.5624H2.3999C2.48293 13.9784 2.93184 15.3143 3.56701 16.4999H6.88573C6.59855 15.2975 6.42631 13.9707 6.38938 12.5624ZM11.4374 11.4374V7.4999H8.04886C7.74099 8.6915 7.55454 10.0303 7.51378 11.4374H11.4374ZM11.4374 6.3749V2.3999C10.2056 2.74393 9.11454 4.31776 8.39446 6.3749H11.4374ZM11.4374 21.5999V17.6249H8.39446C9.11454 19.682 10.2056 21.2559 11.4374 21.5999ZM12.5624 2.3999V6.3749H15.6053C14.8853 4.31776 13.7942 2.74393 12.5624 2.3999ZM16.486 11.4374C16.4452 10.0303 16.2588 8.6915 15.9509 7.4999H12.5624V11.4374H16.486ZM11.4374 12.5624H7.51378C7.55458 13.9696 7.74099 15.3083 8.04886 16.4999H11.4374V12.5624ZM16.8003 6.3749H19.7159C18.5516 4.78217 16.9124 3.43659 15.0028 2.80276C15.7367 3.66916 16.3505 4.97203 16.8003 6.3749ZM7.19949 17.6249H4.28386C5.4482 19.2176 7.08736 20.5632 8.99701 21.197C8.2631 20.3306 7.64926 19.0278 7.19949 17.6249ZM7.19949 6.3749C7.64923 4.97203 8.2631 3.66916 8.99698 2.80276C7.08736 3.43659 5.4482 4.78217 4.28386 6.3749H7.19949ZM16.8003 17.6249C16.3506 19.0278 15.7367 20.3306 15.0028 21.197C16.9124 20.5632 18.5516 19.2176 19.716 17.6249H16.8003ZM12.5624 12.5624V16.4999H15.9509C16.2588 15.3083 16.4453 13.9696 16.486 12.5624H12.5624ZM17.1141 7.4999C17.4013 8.70234 17.5735 10.0291 17.6104 11.4374H21.5999C21.5169 10.0214 21.068 8.68546 20.4328 7.4999H17.1141ZM12.5624 17.6249V21.5999C13.7942 21.2559 14.8853 19.682 15.6053 17.6249H12.5624ZM21.5999 12.5624H17.6104C17.5735 13.9707 17.4013 15.2975 17.1141 16.4999H20.4328C21.068 15.3143 21.5169 13.9784 21.5999 12.5624Z",
    fill: "#8B9DBC"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 4,
    height: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 22C20.2091 22 22 20.2091 22 18C22 15.7909 20.2091 14 18 14C15.7909 14 14 15.7909 14 18C14 20.2091 15.7909 22 18 22ZM19.8536 17.3536C20.0488 17.1583 20.0488 16.8417 19.8536 16.6464C19.6583 16.4512 19.3417 16.4512 19.1464 16.6464L17.5 18.2929L16.8536 17.6464C16.6583 17.4512 16.3417 17.4512 16.1464 17.6464C15.9512 17.8417 15.9512 18.1583 16.1464 18.3536L17.1464 19.3536C17.3417 19.5488 17.6583 19.5488 17.8536 19.3536L19.8536 17.3536Z",
    fill: "#00D25A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45672_72336"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 19.2,
    fill: "white",
    transform: "translate(2.3999 2.3999)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQbConnectedIcon);
export default __webpack_public_path__ + "static/media/QBConnectedIcon.dedbe3a69c88516042c8331ca31c9b31.svg";
export { ForwardRef as ReactComponent };